import * as Yup from "yup";
import {
  requiredText,
  // requiredTextWithZeroToHundred,
} from "@/services/schemas/genericSchemas";

export const InitialValues = {
  fieldName: "",
  fieldType: "",
  fieldSubType: "",
  description: "",
  isImportant: false,
  leadCustomOptions: [{ value: "" }],
};

export const formSchema = Yup.object().shape({
  fieldName: requiredText.trim(),
  fieldType: requiredText,
  fieldSubType: requiredText,
  leadCustomOptions: Yup.array().test({
    test: (options, { createError, resolve, path }) => {
      const fieldType = resolve(Yup.ref("fieldType"));
      if (fieldType === "4" || fieldType === "5") {
        if (
          options.length > 0 &&
          options.every((item) => item?.value?.trim())
        ) {
          return true;
        } else if (options.length > 0) {
          let errors = [];
          options.forEach((item, index) => {
            const propertyValue = item?.value?.trim() || "";
            if (!propertyValue) {
              errors.push(
                createError({
                  path: `${path}[${index}]`,
                  message: "Option cannot be empty.",
                })
              );
            }
          });
          if (errors && errors.length) {
            throw new Yup.ValidationError(errors);
          }
        }
      }
      return true;
    },
  }),
});
